<tpm-carousel class="news-carousel">
  <tpm-carousel-inner>
    <tpm-carousel-item
      *ngFor="let props of marketplaceList; trackBy: trackByIndex"
      (click)="marketplaceItemClicked.emit($any(props))"
      [interval]="7000"
    >
      <tpm-marketplace-carousel-item [props]="$any(props)" [isMobile]="isMobile"></tpm-marketplace-carousel-item>
    </tpm-carousel-item>
    <tpm-carousel-item
      *ngFor="let props of newsList; trackBy: trackByIndex"
      [interval]="5000"
      (click)="newsItemClicked.emit($any(props))"
    >
      <tpm-news-carousel-item
        [props]="props"
        [isMobile]="isMobile"
        [showBadge]="overlay === 'regulated'"
      ></tpm-news-carousel-item>
    </tpm-carousel-item>
  </tpm-carousel-inner>
  <tpm-carousel-indicators
    *ngIf="(marketplaceList?.length ?? 0) + (newsList?.length ?? 0) > 1"
    class="news-carousel-indicators"
    [class.news-carousel-indicators--shifted]="!isMobile"
  ></tpm-carousel-indicators>
</tpm-carousel>
